import dot from "dot";

let tpl_tabs = require("./chattabs.html");

/**
 * 
 * @param isLangKeRoom 是否是浪客
 * @param isSpecialStatus 是否不是普通
 * @param isPresenter 是否是主持人
 * @param isguest 是否是嘉宾
 * @param isAdmin 主持人嘉宾条件下是否要展示主持人嘉宾视角
 */
export default function loadChatTabs(isLangKeRoom: boolean, isSpecialStatus: boolean, isPresenter: boolean, isguest: boolean, isAdmin: boolean) {
    if (!isSpecialStatus) {
        $("#refreshActions").find(".order").hide();
    }
    let data = { isLangKeRoom, isSpecialStatus, isPresenter, isguest, isAdmin }
    let $str = dot.template(tpl_tabs)(data);

    $('.luyan_tabs').html($str)
};